import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class LoadingService {

  public loadingRequestSource: Observable<boolean>;
  private loadingRequestSubject: Subject<boolean>;

  constructor() {
    this.loadingRequestSubject = new Subject<boolean>();
    this.loadingRequestSource = this.loadingRequestSubject.asObservable();
  }

  public getLoadingRequestIntercepted() {
    return this.loadingRequestSource;
  }

  public hideLoading() {
    return this.loadingRequestSubject.next(false);
  }

  public showLoading() {
    return this.loadingRequestSubject.next(true);
  }
}
